import React from 'react';
import PropTypes from 'prop-types';
import css from './Review.css';
import Time from './Time';
import TeamMember from './TeamMember';
import Location from './Location';
import Reason from './Reason';
import Details from './Details';
import Course from './Course';
import MeetingInstructions from './MeetingInstructions';
import {SFEntityID} from "../../../utils/types";
import GroupSessionParticipants from "./GroupSessionParticipants";

export default class Review extends React.Component {

  get teamMember() {
    if ( !this.props.displayTeamMember ) return null;
    return (
      <TeamMember
        name={this.props.ownerName}
        title={this.props.ownerTitle}
        photoURL={this.props.ownerPhotoURL}
      />
    );
  }

  get courseLink() {
    if( !(this.props.courseOptions && this.props.courseOptions.length > 0) ) return null;
    return (
      <Course courseName={this.props.courseName}
              canChangeCourse={this.props.canChangeCourse}
              onAddCourseClicked={this.props.onAddCourseClicked}
      />
    );
  }

  get meetingInstructions() {
    if ( !this.props.scheduleBlockInstructions ) return null;
    return <MeetingInstructions instructions={this.props.scheduleBlockInstructions} />;
  }

  render() {
    return (
      <div className={css['content']}>
        <div>Does this look correct?</div>
        <div className={css['container']}>
          <div>
            <Time
              startDate={this.props.startDate}
              duration={this.props.duration}
              recurring={this.props.recurring}
              recurrenceLabel={this.props.recurrenceLabel}
              canChangeDuration={this.props.canChangeDuration}
              onChangeDurationClicked={this.props.onChangeDurationClicked}
            />
            {this.teamMember}
            <Location
              canChangeLocation={this.props.canChangeLocation}
              locationId={this.props.locationId}
              locationName={this.props.locationName}
              locations={this.props.locations}
              instructions={this.props.instructions}
              onLocationSelected={this.props.onLocationSelected}
            />
            {this.meetingInstructions}
            <GroupSessionParticipants participants={this.props.participants} />
          </div>
          <div>
            <Reason
              name={this.props.reasonName}
              onChangeReasonClicked={this.props.onChangeReasonClicked}
            />
            {this.courseLink}
            <Details value={this.props.details} onChange={this.props.onDetailsChanged} />
          </div>
        </div>
      </div>
    );
  }
}

Review.propTypes = {
  startDate: PropTypes.object.isRequired,
  duration: PropTypes.number.isRequired,
  locationId: SFEntityID,
  locationName: PropTypes.string,
  locations: PropTypes.array,
  instructions: PropTypes.string,
  reasonName: PropTypes.string.isRequired,
  displayTeamMember: PropTypes.bool,
  ownerName: PropTypes.string,
  ownerTitle: PropTypes.string,
  ownerPhotoURL: PropTypes.string,
  recurring: PropTypes.bool,
  recurrenceLabel: PropTypes.string,
  courseOptions: PropTypes.array,
  courseName: PropTypes.string,
  onChangeReasonClicked: PropTypes.func.isRequired,
  details: PropTypes.string.isRequired,
  onDetailsChanged: PropTypes.func.isRequired,
  canChangeDuration: PropTypes.bool,
  canChangeLocation: PropTypes.bool,
  canChangeCourse: PropTypes.bool,
  onChangeDurationClicked: PropTypes.func.isRequired,
  onLocationSelected: PropTypes.func,
  onAddCourseClicked: PropTypes.func.isRequired,
  scheduleBlockInstructions: PropTypes.string,
  participants: PropTypes.array
};
